import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartnersComponent} from './partners/partners.component';
import {RouterModule} from '@angular/router';
import {EditPartnersComponent} from './edit-partners/edit-partners.component';
import {ShowPartnersComponent} from './show-partners/show-partners.component';
import {NxCardModule} from '@aposin/ng-aquila/card';
import {NxIconModule} from '@aposin/ng-aquila/icon';
import {ComponentsModule} from '../../components/components.module';
import {NxHeadlineModule} from '@aposin/ng-aquila/headline';
import {NxGridModule} from '@aposin/ng-aquila/grid';
import {NxButtonModule} from '@aposin/ng-aquila/button';
import {NxFormfieldModule} from '@aposin/ng-aquila/formfield';
import {NxInputModule} from '@aposin/ng-aquila/input';
import {FormsModule} from '@angular/forms';
import {NxDropdownModule} from "@aposin/ng-aquila/dropdown";
import {NxSwitcherModule} from "@aposin/ng-aquila/switcher";
import {NxImageModule} from "@aposin/ng-aquila/image";
import {PipeModule} from "../../pipe/pipe.module";
import {NxListModule} from "@aposin/ng-aquila/list";


@NgModule({
  declarations: [
    PartnersComponent,
    EditPartnersComponent,
    ShowPartnersComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        NxCardModule,
        NxIconModule,
        ComponentsModule,
        NxHeadlineModule,
        NxGridModule,
        NxButtonModule,
        NxFormfieldModule,
        NxInputModule,
        FormsModule,
        NxDropdownModule,
        NxSwitcherModule,
        NxImageModule,
        PipeModule,
        NxListModule,
    ]
})
export class PartnerModule {
}
